import { useAuthStore } from '../stores/auth';
import api from './api';

export const authService = {
  async login(email, password) {
    const authStore = useAuthStore();
    const success = await authStore.login(email, password);
    
    if (!success) {
      throw new Error(authStore.error || 'Login failed');
    }
    
    console.log('Login successful, authenticated:', authStore.isAuthenticated);
    return authStore.currentUser;
  },

  async register(userData) {
    // Ensure password_confirmation is set
    if (userData.password && !userData.password_confirmation) {
      userData.password_confirmation = userData.password;
    }
    
    const authStore = useAuthStore();
    const success = await authStore.register(userData);
    
    if (!success) {
      throw new Error(authStore.error || 'Registration failed');
    }
    
    console.log('Registration successful, authenticated:', authStore.isAuthenticated);
    return authStore.currentUser;
  },

  async logout() {
    try {
      // Call the logout API endpoint
      await api.auth.logout();
    } catch (error) {
      console.error('Logout API call failed:', error);
    } finally {
      // Always clear local state even if API call fails
      const authStore = useAuthStore();
      authStore.logout();
      console.log('Logout completed, authenticated:', authStore.isAuthenticated);
    }
  },

  getCurrentUser() {
    const authStore = useAuthStore();
    console.log('Current authentication status:', authStore.isAuthenticated);
    return authStore.currentUser;
  },

  async requestPasswordReset(email) {
    try {
      const response = await api.auth.requestPasswordReset(email);
      return response.data;
    } catch (error) {
      console.error('Password reset request error:', error);
      throw new Error(error.response?.data?.message || 'Failed to send reset code');
    }
  },

  async verifyPasswordReset(code, password, passwordConfirmation) {
    try {
      const response = await api.auth.verifyPasswordReset({
        code,
        password,
        password_confirmation: passwordConfirmation
      });
      return response.data;
    } catch (error) {
      console.error('Password reset verification error:', error);
      throw new Error(error.response?.data?.message || 'Failed to reset password');
    }
  },

  async masqueradeUser(userId) {
    try {
      const response = await api.admin.masqueradeUser(userId);
      
      if (response.data.success && response.data.access_token) {
        const authStore = useAuthStore();
        
        // Store the masquerade token and user info
        await authStore.setMasqueradeUser(
          response.data.access_token,
          response.data.user,
          response.data.admin_user
        );
        
        return response.data;
      } else {
        throw new Error('Invalid masquerade response');
      }
    } catch (error) {
      console.error('Masquerade error:', error);
      throw new Error(error.response?.data?.message || 'Failed to masquerade user');
    }
  },

  async stopMasquerade() {
    try {
      const authStore = useAuthStore();
      
      // Call stop masquerade API if available
      try {
        await api.admin.stopMasquerade();
      } catch (apiError) {
        console.warn('Stop masquerade API call failed:', apiError);
        // Continue with local cleanup even if API call fails
      }
      
      // Restore original admin session
      await authStore.stopMasquerade();
      
      return true;
    } catch (error) {
      console.error('Stop masquerade error:', error);
      throw new Error(error.response?.data?.message || 'Failed to stop masquerade');
    }
  }
}; 